import { jsx as _jsx } from "react/jsx-runtime";
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { createBrowserHistory } from '@tanstack/history';
import { routeTree } from './routes';
export var router = createRouter({
    routeTree: routeTree,
    history: createBrowserHistory()
});
var Router = function () {
    return _jsx(RouterProvider, { router: router });
};
export default Router;
